import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSession } from './session';

export const CHANGE_PASSWORD_PATH = '/account/password';

/**
 * Sends signed-out visitors to /login, remembering where they were going. An account that must
 * change its password is held on the change-password page until it does.
 */
export function RequireAuth({ children }: { children: ReactNode }) {
  const { signedIn, mustChangePassword } = useSession();
  const location = useLocation();
  if (!signedIn) {
    return (
      <Navigate to="/login" replace state={{ from: `${location.pathname}${location.search}` }} />
    );
  }
  if (mustChangePassword && location.pathname !== CHANGE_PASSWORD_PATH) {
    return <Navigate to={CHANGE_PASSWORD_PATH} replace />;
  }
  return <>{children}</>;
}
